<template>
    <v-container fluid>
        <ApolloQuery
            :query="require('@/graphql/subscription/allSubscriptions.gql')"
        >
            <template v-slot="{ result: { loading, error, data } }">
                <v-progress-linear indeterminate v-if="loading" />
                <v-data-table
                    v-if="data && !loading"
                    :items="filterSubscriptions(data.allSubscriptions)"
                    :headers="headers"
                    item-key="id"
                    :items-per-page.sync="itemsPerPage"
                    show-select
                    :footer-props="{ itemsPerPageOptions }"
                >
                    <template v-slot:item.stripe_status="{ item }">
                        <v-chip
                            :color="subscriptionStatusMap[item.stripe_status].color"
                            :text-color="subscriptionStatusMap[item.stripe_status].text"
                            small
                        >{{ subscriptionStatusMap[item.stripe_status].name }}</v-chip>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-icon @click="showSubscription(item)" class="mr-2">
                            mdi-eye
                        </v-icon>
                        <v-icon @click="openSubscription(item)">
                            mdi-open-in-new
                        </v-icon>
                    </template>
                </v-data-table>
                <v-alert type="error" v-else-if="error">
                    There was an error loading data. The server said...<br />
                    <strong>{{ error }}</strong>
                </v-alert>
            </template>
        </ApolloQuery>
    </v-container>
</template>

<script>
import { subscriptionStatusMap } from '@/subscriptionStatuses'

export default {
    name: 'SubscriptionsGrid',
    props: {
        reload: {
            type: Number,
            default: 0,
        },
        client_id: {
            type: String,
        },
        tier: {
            type: String,
            default: null,
        },
        status: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        itemsPerPageOptions: [25, 50, 100],
        itemsPerPage: 25,
        selected: [],
        rando: 0,
        headers: [
            { text: 'Client', value: 'client.name' },
            { text: 'Status', value: 'stripe_status' },
            { text: 'User', value: 'user.name' },
            { text: 'Tier', value: 'name' },
            {
                text: 'Actions',
                align: 'right',
                sortable: false,
                value: 'action',
            },
        ],
        subscriptionStatusMap,
    }),
    watch: {
        reload: function(val) {
            this.rando = val
        },
    },
    computed: {
        query_vars: function() {
            return { client_id: this.client_id, garbage: this.rando }
        },
    },
    methods: {
        filterClientId(subscription) {
            if (this.client_id) {
                if (subscription.client) {
                    return this.client_id === subscription.client.id
                }

                return false
            }

            return true
        },
        filterTier(subscription) {
            if (this.tier) {
                return subscription.stripe_plan === this.tier
            }

            return true
        },
        filterStatus(subscription) {
            if (this.status) {
                return subscription.stripe_status === this.status
            }

            return true
        },
        filterSubscriptions(subscriptions) {
            return subscriptions
                .filter(this.filterClientId)
                .filter(this.filterTier)
                .filter(this.filterStatus)
        },
        showSubscription(subscription) {
            this.$emit('show-subscription', subscription)
        },
        openSubscription(subscription) {
            window.open(subscription.stripe_url, '_blank', 'noopener,noreferrer')
        },
    },
}
</script>
